import { render } from "./Loader.vue?vue&type=template&id=8c818a12&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=8c818a12&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c818a12"]])

export default __exports__